<template>
  <div class="bg-white shadow-sm sm:rounded-lg">
    <div class="px-4 py-5 sm:px-6">
      <h3 class="text-lg leading-6 font-medium text-gray-900">
        {{ product.title }}
      </h3>
      <p class="mt-1 max-w-2xl text-sm text-gray-500">{{ $t("by") }} {{ product.vendor }}</p>
      <img :src="product.imageUrl" :alt="product.title" class="h-1/4 w-1/4" />
    </div>
    <div class="border-t border-gray-200 px-4 py-5 sm:p-0">
      <dl class="sm:divide-y sm:divide-gray-200">
        <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-sm font-medium text-gray-500">{{ $t("Name") }}</dt>
          <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
            {{ product.title }}
          </dd>
        </div>
        <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-sm font-medium text-gray-500">Reference</dt>
          <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
            {{ product.referenceId }}
          </dd>
        </div>
        <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-sm font-medium text-gray-500">
            {{ $t("Product Type") }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
            {{ $t(`${product.productType}`) }}
          </dd>
        </div>
        <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-sm font-medium text-gray-500">{{ $t("Vendor") }}</dt>
          <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
            {{ product.vendor }}
          </dd>
        </div>
        <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="inline-flex text-sm font-medium text-gray-500">
            <p>{{ $t("Approval status") }}</p>
          </dt>
          <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
            <FieldSpan
              :style-to-add="approvalStatusListStyle(product.approvalStatus)"
              :value="product.approvalStatus"
            />
          </dd>
        </div>
        <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="inline-flex text-sm font-medium text-gray-500">
            <p>{{ $t("Contract status") }}</p>
          </dt>
          <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
            <FieldSpan
              :style-to-add="contractStatusListStyle(product.contractStatus)"
              :value="product.contractStatus"
            />
          </dd>
        </div>
        <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="inline-flex text-sm font-medium text-gray-500">
            <p>{{ $t("Published") }}</p>
          </dt>
          <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
            <FieldSpan :style-to-add="getEnabledFieldDisplayStyle(product.enabled)" :value="product.enabled" />
          </dd>
        </div>
      </dl>
    </div>
  </div>
</template>

<script>
import { FieldSpan } from "@estaly/ui";
import { mapGetters } from "vuex";

export default {
  components: {
    FieldSpan,
  },
  props: ["product"],
  computed: {
    ...mapGetters("products", ["approvalStatusListStyle", "contractStatusListStyle"]),
  },
  methods: {
    getEnabledFieldDisplayStyle(isEnabled) {
      return isEnabled ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800";
    },
  },
};
</script>
